import { ReactNode } from 'react';

import { Label, Message } from '@iwoca/orion';
import cn from 'classnames';
import { twMerge } from 'tailwind-merge';

type DebitCardFieldWrapperProps = {
    label: ReactNode;
    htmlFor?: string;
    error?: string | null;
    className?: string;
    children: ReactNode;
};

export const DebitCardFieldWrapper = ({
    label,
    htmlFor,
    error,
    className,
    children
}: DebitCardFieldWrapperProps) => (
    <div
        className={twMerge(
            cn('relative mb-l flex w-full max-w-[312px] flex-col', className)
        )}
    >
        <Label
            htmlFor={htmlFor}
            className="text-base mb-m flex items-center gap-m font-bold text-primary-10"
        >
            {label}
        </Label>
        {children}
        {error && <Message message={error} type="error" className="mt-s" />}
    </div>
);
